import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export interface ChartOfAccount {
  id: string;
  company_id: string;
  account_number: string;
  name: string;
  account_type: "income" | "cogs" | "expense" | "liability" | "asset" | "equity";
  parent_account: string | null;
  qb_account_id: string | null;
  qb_account_name: string | null;
  is_active: boolean;
  created_at: string;
}

export function useChartOfAccounts() {
  const { user } = useAuth();
  return useQuery<ChartOfAccount[]>({
    queryKey: ["chart_of_accounts"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("chart_of_accounts")
        .select("*")
        .eq("is_active", true)
        .order("account_number");
      if (error) throw error;
      return (data ?? []) as unknown as ChartOfAccount[];
    },
    enabled: !!user,
  });
}

export function useUpdateChartOfAccount() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, ...input }: Partial<ChartOfAccount> & { id: string }) => {
      const { data, error } = await supabase
        .from("chart_of_accounts")
        .update(input as any)
        .eq("id", id)
        .select("*")
        .single();
      if (error) throw error;
      return data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["chart_of_accounts"] }),
  });
}
